import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

function WhistleblowingPolicy() {
  return (
    <>
      <Header />
      <main className="main" style={{ background: 'linear-gradient(135deg, #FDFCFE 0%, #FAF8FC 50%, #F5EBFA 100%)', minHeight: '100vh' }}>
        {/* Hero Section */}
        <section style={{
          background: 'linear-gradient(to bottom, rgba(15, 23, 42, 0.7) 0%, rgba(30, 41, 59, 0.8) 100%), url(/assets/img/dtk4.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
          minHeight: '65vh',
          display: 'flex',
          alignItems: 'center',
          position: 'relative',
          overflow: 'hidden'
        }}>
          <div style={{
            content: '',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 100 100\' fill=\'rgba(255,255,255,0.03)\'%3E%3Ccircle cx=\'25\' cy=\'25\' r=\'1\'/%3E%3Ccircle cx=\'75\' cy=\'75\' r=\'1.5\'/%3E%3C/svg%3E")',
            backgroundSize: '80px 80px',
            backgroundRepeat: 'repeat',
            animation: 'float 20s ease-in-out infinite'
          }}></div>
          <div className="container" style={{ position: 'relative', zIndex: 2 }}>
            <div className="row">
              <div className="col-lg-10 mx-auto text-center">
                <div style={{
                  backgroundColor: 'rgba(123, 63, 158, 0.15)',
                  backdropFilter: 'blur(10px)',
                  borderRadius: '24px',
                  padding: '60px 50px 40px',
                  color: 'white'
                }}>
                  <h2 style={{ fontSize: '2.5rem', fontWeight: '700', marginBottom: '10px', textShadow: '0 2px 10px rgba(123, 63, 158, 0.97)', color: '#fff' }}>
                    DTK WHISTLEBLOWING POLICY AND PROCEDURE
                  </h2>
                  <p style={{ fontSize: '1.2rem', marginBottom: 0, opacity: 0.95 }}>
                    Speaking Up With Confidence and Protection
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Policy Information Table */}
        <section style={{ padding: '80px 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="shadow-lg" style={{
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  overflow: 'hidden',
                  border: '1px solid #e2e8f0'
                }}>
                  <div className="table-responsive">
                    <table className="table mb-0" style={{ fontSize: '1rem' }}>
                      <tbody>
                        <tr style={{ borderBottom: '1px solid #e2e8f0' }}>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc', width: '30%' }}>Lead Responsibility</td>
                          <td style={{ padding: '20px 30px' }}>Akindele Bakarey</td>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc', width: '25%' }}>Approved by</td>
                          <td style={{ padding: '20px 30px' }}>Adekunle Ayeni</td>
                        </tr>
                        <tr style={{ borderBottom: '1px solid #e2e8f0' }}>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc' }}>Version</td>
                          <td style={{ padding: '20px 30px' }}>V7 - 2025</td>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc' }}>Date of Approval</td>
                          <td style={{ padding: '20px 30px' }}>01/12/25</td>
                        </tr>
                        <tr style={{ borderBottom: '1px solid #e2e8f0' }}>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc' }}>Effective from</td>
                          <td style={{ padding: '20px 30px' }}>01/12/25</td>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc' }}>Next review date</td>
                          <td style={{ padding: '20px 30px' }}>01/12/26</td>
                        </tr>
                        <tr style={{ borderBottom: '1px solid #e2e8f0' }}>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc' }}>Policy applicable to</td>
                          <td colSpan="3" style={{ padding: '20px 30px' }}><strong>ALL EMPLOYEES and FREELANCE STAFF</strong></td>
                        </tr>
                        <tr>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc' }}>Record of Changes:</td>
                          <td colSpan="3" style={{ padding: '20px 30px' }}>10.3 – Contact details changed</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 1. Introduction */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    1. Introduction
                  </h3>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    1.1 DTK is committed to operating in an ethical and principled way. The aim of this policy and procedure is to provide employees and workers (referred to as 'workers' in this policy) with a means for raising genuine concerns of suspected bribery, breaches of the law and other serious wrongdoings.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    1.2 DTK encourages workers to raise genuine concerns about suspected wrongdoing at the earliest practicable stage. This policy and procedure are intended to provide safeguards to enable members of staff to raise concerns about malpractice in connection with DTK.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    1.3 This policy and procedure also aims to encourage workers to raise genuine concerns through internal DTK procedures without fear of adverse repercussions being taken against them. The law allows workers to raise such concerns externally and this policy informs workers how they can do so. However, a failure to raise a concern under this procedure may result in a disclosure losing its protected status under the law.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    1.4 This policy and procedure also seeks to balance the need to allow a culture of openness against the need to protect other workers against vexatious allegations or allegations which are not well-founded.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    1.5 The principles of openness and accountability which underpin legislation protecting whistle blowers are reflected in this policy and procedure. DTK is also committed to ensuring compliance with the Bribery Act 2010.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    1.6 Learners at DTK are also encouraged to raise genuine concerns about suspected wrongdoing by making a complaint to the student support services. This policy and procedure are designed for the use of workers of DTK.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 2. Applicability */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    2. Applicability of this policy and procedure
                  </h3>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    2.1 This policy applies to all employees of DTK, including apprentices; and
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    2.2 Workers which includes any casual workers; home-based casual workers; and employees of subcontractors; and
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    2.3 Agency workers engaged by DTK.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    2.4 Workers might be unsure whether it is appropriate to raise their concern under this policy and procedure or whether it is a personal grievance, which is more appropriate to raise under DTK' grievance procedure. Any worker in this situation is encouraged to approach the Director in confidence for advice.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 3. Protected disclosures */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    3. Protected disclosures
                  </h3>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    3.1 The law protects workers who, out of a sense of public duty, want to reveal suspected wrongdoing or malpractice.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    3.2 The law allows workers to raise what it defines as a 'protected disclosure'. To be a protected disclosure, a disclosure must relate to a specific subject matter (See Section 4 below) and the disclosure must also be made in an appropriate way (See Section 5). A 'protected disclosure' must, in the reasonable belief of the worker making it, also be made in the public interest. A protected disclosure must consist of information and not merely be allegations of suspected malpractice.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 4. Specific Subject Matter */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    4. Specific Subject Matter
                  </h3>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    4.1 If, in the course of employment, a worker becomes aware of information which they reasonably believe tends to show one or more of the following, they must use this policy and procedure:
                  </p>

                  <ul style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', paddingLeft: '30px', marginBottom: '0' }}>
                    <li>That a criminal offence has been committed, is being committed or is likely to be committed,</li>
                    <li>That an individual has failed, is failing or is likely to fail to comply with any legal obligation to which they are subject,</li>
                    <li>That a miscarriage of justice has occurred, is occurring, or is likely to occur,</li>
                    <li>That the health or safety of any individual has been, is being, or is likely to be, endangered,</li>
                    <li>That the environment, has been, is being, or is likely to be, damaged,</li>
                    <li>That information tending to show any of the above, is being, or is likely to be, deliberately concealed.</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 5. Procedure for making a disclosure */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    5. Procedure for making a disclosure
                  </h3>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    5.1 Information which a worker reasonably believes tends to show one or more of the situations given in Section 4 should promptly be disclosed to the Director so that any appropriate action can be taken.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    5.2 If it is inappropriate to make such a disclosure to their line manager, a worker can raise the issue with Dele Bakarey.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Continue in next section... */}
        {/* 6. Procedure for investigation */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    5.3 If the disclosure relates to the Principal and Chief Executive, a worker can raise the issue with ESFA.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    5.4 Workers are encouraged to identify themselves when making a disclosure. If an anonymous disclosure is made, DTK will not be able to notify the individual making the disclosure of the outcome of action taken by DTK. Anonymity also means that DTK will have difficulty in investigating such a concern. DTK reserves the right to determine whether to apply this procedure in respect of an anonymised disclosure considering the following considerations:
                  </p>

                  <ul style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', paddingLeft: '30px', marginBottom: '20px' }}>
                    <li>The seriousness of the issues raised in the disclosure,</li>
                    <li>The credibility of the concern,</li>
                    <li>How likely it is that the concern can be confirmed from attributable sources.</li>
                  </ul>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    5.5 For further guidance in relation to this policy and procedure, or concerning the use of the disclosure procedure generally, employees should speak in confidence to the Director.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 6. Procedure for investigation of a disclosure */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    6. Procedure for investigation of a disclosure
                  </h3>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    6.1 When a worker makes a disclosure, DTK will acknowledge its receipt, in writing, within a reasonable time. (maximum of 10 working days)
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    6.2 DTK will then determine whether it believes that the disclosure is wholly without substance or merit. If DTK considers that the disclosure does not have sufficient merit to warrant further action, the worker will be notified in writing of the reasons for DTK' decision and advised that no further action will be taken by DTK under this policy and procedure. Considerations to be considered when making this determination may include the following:
                  </p>

                  <ul style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', paddingLeft: '30px', marginBottom: '20px' }}>
                    <li>If DTK is satisfied that a worker does not have a reasonable belief that suspected malpractice is occurring or,</li>
                    <li>If the matter is already the subject of legal proceedings or appropriate action by an external body or,</li>
                    <li>If the matter is already subject to another, appropriate procedure.</li>
                  </ul>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    6.3 When a worker makes a disclosure which has sufficient substance or merit warranting further action, DTK will act as it deems appropriate (including action under any other applicable DTK policy or procedure). Possible actions could include internal investigation; referral to DTK' auditors; or referral to relevant external bodies such as the police, OFSTED, Health and Safety Executive, ESFA or the Information Commissioner's Office.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Continue sections 6.4 to 6.6 */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    6.4 If appropriate, any internal investigation would be conducted by a manager of DTK without any direct association with the individual to whom the disclosure relates, or by an external investigator appointed by DTK as appropriate. [Guidance note: Depending on the seriousness of the concern raised and the seniority of the worker making the disclosure, it would be appropriate for a senior manager or a designated officer to investigate the concern].
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    6.5 Any recommendations for further action made by DTK will be addressed to the Director of DTK as appropriate in the circumstances. The recipient will take all steps within their power to ensure the recommendations are implemented unless there are good reasons for not doing so.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    6.6 The worker making the disclosure will be notified of the outcome of any action taken by DTK under this policy and procedure within a reasonable period. If the worker is not satisfied that their concern has been appropriately addressed, they can appeal against the outcome by raising the issue with the Director within 10 working days. The Director will make a final decision on action to be taken and notify the worker making the disclosure. Whistleblowing: The procedure should encourage the expeditious investigation of disclosures and can specify timelines for different stages of the procedure. However, timescales should be flexible, considering that different types of concerns will require varying time for investigation. All communications with the worker making the disclosure should be in writing and sent to the worker's home address rather than through DTK' internal mail. If investigations into the concern are prolonged, DTK should keep the worker concerned updated as to the progress of the investigation and an estimated timeframe for its conclusion.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 7. Safeguards for workers making a disclosure */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    7. Safeguards for workers making a disclosure
                  </h3>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    7.1 A worker making a disclosure under this procedure can expect their matter to be treated confidentially by DTK and, where applicable, their name will not be disclosed to anyone implicated in the suspected wrongdoing, without their prior approval. [Guidance note: For confidentiality purposes, if the worker requests to raise their concern verbally, it would be appropriate for DTK to allow the worker to do so.]
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    7.2 DTK will take all reasonable steps to ensure that any report of recommendations, or other relevant documentation, produced by DTK does not identify the worker making the disclosure without their written consent, or unless DTK is legally obliged to do so, or for the purposes of seeking legal advice.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    7.3 No formal disciplinary action will be taken against a worker on the grounds of making a disclosure made under this policy or procedure. This does not prevent DTK from bringing disciplinary action against a worker where DTK has grounds to believe that a disclosure was made maliciously or vexatiously, or where a disclosure is made outside of DTK without reasonable grounds.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 7.4 and 8. Disclosure to external bodies */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '30px' }}>
                    7.4 A worker will not suffer dismissal or any detrimental action or omission of any type (including informal pressure or any form of victimisation) by DTK for making a disclosure in accordance with this policy and procedure. Equally, where a worker is threatened, bullied, pressurised, or victimised by a colleague for making a disclosure, disciplinary action will be taken by DTK against the colleague in question.
                  </p>

                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    8. Disclosure to external bodies
                  </h3>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    8.1 This policy and procedure has been implemented to allow workers to raise disclosures internally within DTK. A worker has the right to make a disclosure outside of DTK where there are reasonable grounds to do so and in accordance with the law.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    8.2 Workers may make a disclosure to an appropriate external body prescribed by the law. This list of 'prescribed' organisations and bodies can be found in information on the GOV.UK website.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    8.3 Workers can also make disclosures on a confidential basis to a practising solicitor or barrister.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    8.4 If a worker seeks advice outside of DTK, they must be careful not to breach any confidentiality obligations or damage DTK' reputation in so doing.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 9. Accountability and 10. Further assistance */}
        <section style={{ padding: '0 0 80px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    9. Accountability
                  </h3>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '40px' }}>
                    9.1 DTK will keep a record of all concerns raised under this policy and procedure (including cases where DTK deems that there is no case to answer and therefore that no action should be taken) and will report to the Director on an annual basis as appropriate.
                  </p>

                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    10. Further assistance for workers
                  </h3>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    10.1 DTK will not tolerate any harassment or victimisation of workers who make disclosures. If, at any stage of this procedure a worker feels that they are being subject to informal pressures, bullying or harassment due to making a disclosure, they should raise this matter, in writing, to the Director.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    10.2 A worker making a disclosure may want to confidentially request counselling or other support from DTK' occupational health service. Any such request for counselling or support services should be addressed to the Director. Such a request would be made in confidence.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    10.3 Workers can also contact the ACAS helpline for confidential advice on whistleblowing issues. Contact details are as follows:
                  </p>

                  <div style={{ 
                    backgroundColor: '#F5EBFA',
                    border: '2px solid #7B3F9E',
                    borderRadius: '12px',
                    padding: '25px',
                    marginBottom: '0'
                  }}>
                    <p style={{ color: '#1e293b', fontSize: '1.1rem', fontWeight: '700', marginBottom: '10px' }}>
                      ACAS helpline
                    </p>
                    <p style={{ color: '#334155', fontSize: '1.05rem', marginBottom: '5px' }}>
                      <strong>Telephone: 0300 123 1100</strong>
                    </p>
                    <p style={{ color: '#334155', fontSize: '1.05rem', marginBottom: '10px' }}>
                      <strong>Monday to Friday, 8am to 6pm or online</strong>
                    </p>
                    <p style={{ color: '#7B3F9E', fontSize: '1.05rem', margin: '0' }}>
                      <a href="https://www.acas.org.uk/advice" target="_blank" rel="noopener noreferrer" style={{ color: '#7B3F9E', textDecoration: 'none', fontWeight: '600' }}>
                        https://www.acas.org.uk/advice
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}

export default WhistleblowingPolicy;